import styled from "styled-components";

export const ContentContainer = styled.div`
    width: 550px;
    height: 100%;

    > div:first-of-type {
        height: auto;
    }
`;
